// Header - Add class on hover
document.addEventListener("DOMContentLoaded", function () {
  const header = document.getElementById("site-header");

  if (header) {
    header.addEventListener("mouseenter", function () {
      header.classList.add("hovered");
    });

    header.addEventListener("mouseleave", function () {
      header.classList.remove("hovered");
    });
  }
});

// Product card - Change image on swatch click
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".product-card").forEach(function (productCard) {
    const activeSwatch = productCard.querySelector(
      ".family-swatch.variante-activa"
    );
    if (activeSwatch) {
      const swatchId = activeSwatch.dataset.swatchId;
      productCard.querySelectorAll(".card__media").forEach(function (media) {
        media.classList.toggle("active", media.dataset.swatchId === swatchId);
      });
    }

    productCard.querySelectorAll(".family-swatch").forEach(function (swatch) {
      swatch.addEventListener("click", function (e) {
        e.preventDefault();

        const swatchId = swatch.dataset.swatchId;
        const newImage = swatch.dataset.productImage;
        const newUrl = swatch.dataset.productUrl;

        const imageEl = productCard.querySelector(".product-card-image");
        if (imageEl) imageEl.src = newImage;

        const linkEl = productCard.querySelector(".card-product-link");
        if (linkEl) {
          linkEl.href = newUrl;

          const currentAlt = linkEl.getAttribute("alt");
          if (currentAlt && currentAlt.includes("|")) {
            const [baseName] = currentAlt.split("|");
            linkEl.setAttribute("alt", `${baseName.trim()} | ${swatchId}`);
          } else {
            linkEl.setAttribute("alt", swatchId);
          }
        }

        const infolinkEl = productCard.querySelector(".product-info-card-link");
        if (infolinkEl) {
          infolinkEl.href = newUrl;

          const currentAlt = infolinkEl.getAttribute("alt");
          if (currentAlt && currentAlt.includes("|")) {
            const [baseName] = currentAlt.split("|");
            infolinkEl.setAttribute("alt", `${baseName.trim()} | ${swatchId}`);
          } else {
            infolinkEl.setAttribute("alt", swatchId);
          }
        }

        productCard.querySelectorAll(".family-swatch").forEach(function (el) {
          el.classList.remove("variante-activa");
        });
        swatch.classList.add("variante-activa");

        productCard.querySelectorAll(".card__media").forEach(function (media) {
          media.classList.toggle("active", media.dataset.swatchId === swatchId);
        });
      });
    });
  });
});

// Product images slideshow
window.addEventListener("load", () => {
  const wrapper = document.querySelector(".slides-wrapper");
  if (!wrapper) return;

  let slides = wrapper.querySelectorAll(".mySlides");
  const dots = document.querySelectorAll(".dot");
  if (!slides.length) return;

  // Clone first and last slides
  const firstClone = slides[0].cloneNode(true);
  const lastClone = slides[slides.length - 1].cloneNode(true);
  firstClone.classList.add("clone");
  lastClone.classList.add("clone");

  wrapper.appendChild(firstClone);
  wrapper.insertBefore(lastClone, slides[0]);

  slides = wrapper.querySelectorAll(".mySlides");
  const totalSlides = slides.length;

  // 👉 Start at the last real slide (before the final clone)
  let slideIndex = slides.length -3;

  // Position instantly, no animation
  wrapper.style.setProperty("transition", "none", "important");
  wrapper.style.transform = `translateX(-${slideIndex * 100}%)`;
  wrapper.getBoundingClientRect();

  // Re-enable transition for next moves
  requestAnimationFrame(() => {
    wrapper.style.transition = "transform 0.3s ease";
  });

  function updateDots() {
    if (!dots.length) return;
    dots.forEach((dot) => dot.classList.remove("active"));
    let realIndex = (slideIndex - 1 + dots.length) % dots.length;
    if (dots[realIndex]) dots[realIndex].classList.add("active");
  }

  function plusSlides(n) {
    if (n === 0) return;
    slideIndex += n;
    wrapper.style.transition = "transform 0.3s ease";
    wrapper.style.transform = `translateX(-${slideIndex * 100}%)`;
    updateDots();
  }

  function currentSlide(n) {
    slideIndex = n + 1; // +1 because index 0 is the lastClone
    wrapper.style.transition = "transform 0.3s ease";
    wrapper.style.transform = `translateX(-${slideIndex * 100}%)`;
    updateDots();
  }

  wrapper.addEventListener("transitionend", () => {
    if (slides[slideIndex] && slides[slideIndex].classList.contains("clone")) {
      wrapper.style.setProperty("transition", "none", "important");

      if (slideIndex === 0) {
        slideIndex = slides.length - 3; // jump to last real slide
      } else if (slideIndex === slides.length - 1) {
        slideIndex = 1; // jump to first real slide
      }

      wrapper.style.transform = `translateX(-${slideIndex * 100}%)`;
      wrapper.getBoundingClientRect();

      requestAnimationFrame(() => {
        wrapper.style.transition = "transform 0.6s ease";
      });
    }
  });

  window.plusSlides = plusSlides;
  window.currentSlide = currentSlide;

  updateDots();
});



// Menu drawer close
document.addEventListener('DOMContentLoaded', function() {
  const myDiv = document.getElementById('menu-drawer');
  const closeButton = document.getElementById('drawer-close');

  closeButton.addEventListener('click', function() {
    myDiv.classList.add('closed-div');
  });
});

// Re-enable hidden input once a variant is chosen inside pdp
document.addEventListener("DOMContentLoaded", () => {
  const selects = document.querySelectorAll('select[name="id"]');
  selects.forEach(select => {
    select.addEventListener("change", () => {
      const hiddenInput = select.form.querySelector('input[name="id"]');
      hiddenInput.value = select.value;
      hiddenInput.disabled = !select.value;
    });
  });
});

// Recently viewed section
function getRecentlyViewedProducts() {
  var viewedProducts = [];
  var cookie = Cookies.get('recently_viewed_products');
  if (cookie) {
    viewedProducts = JSON.parse(cookie);
  }
  return viewedProducts;
}

function addRecentlyViewedProduct(productId) {
  var viewedProducts = getRecentlyViewedProducts();
  var index = viewedProducts.indexOf(productId);
  if (index > -1) {
    viewedProducts.splice(index, 1);
  }
  viewedProducts.unshift(productId);
  Cookies.set('recently_viewed_products', JSON.stringify(viewedProducts), { expires: 30, path: '/' });
}

// Cart drawer policies
var coll = document.getElementsByClassName("policy");
var i;

for (i = 0; i < coll.length; i++) {
  coll[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var content = this.nextElementSibling;
    if (content.style.display === "block") {
      content.style.display = "none";
    } else {
      content.style.display = "block";
    }
  });
}

// Mobile footer menu
var coll = document.getElementsByClassName("mb-menu-item");
var i;

for (i = 0; i < coll.length; i++) {
  coll[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var content = this.nextElementSibling;
    if (content.style.display === "flex") {
      content.style.display = "none";
    } else {
      content.style.display = "flex";
    }
  });
}